<template>
	<ul>
	    <li class="order-detail">
	        <div class="link-wrap">
				<img src="@/assets/images/order-manage/ic_home_line_7.png" alt="" class="pt-img">
	            <span class="service-left">服务信息</span>
	        </div>
			
			<div class="customer-info">
			    <span class="info-style">服务项目</span>
			    <span class="info-style">{{detailList.server_info.server_name}}</span>
			</div>
			
			<div class="customer-info">
			    <span class="info-style">订单编号</span>
			    <span class="info-style info-r">{{detailList.order_code}}</span>
				<img src="@/assets/images/order-manage/ic_copy.png" alt="" class="copy-logo" @click="utils.copyText(detailList.order_code)"/>
			</div>
			
			<div class="customer-info" v-if="detailList.pay_type && role!='sale'">
			    <span class="info-style">支付方式</span>
			    <span class="info-style">{{detailList.pay_type}}</span>
			</div>
			 
			<div class="customer-info" v-if="role!='sale' && role!='user'">
			    <span class="info-style">订单账号</span>
				<span class="info-style" v-if="detailList.order_tag === '1'">{{detailList.account}}</span>
				<span class="info-style" v-else>管理员</span>
			</div>
			
			<div class="customer-info">
			    <span class="info-style">下单时间</span>
			    <span class="info-style">{{detailList.create_time}}</span>
			</div>
			
			<div class="customer-info discount-wrap" v-if="detailList.is_member==2 && role!='sale'">
			    <span class="info-style">会员优惠</span>
				<div>
					<span class="info-style" :class='role=="user"?"blod-co":""'>已优惠</span>
					<span class="discount" :class='role=="user"?"blod-co":""'>{{detailList.order_member_price}}</span><span class="dan-wei" :class='role=="user"?"blod-co":""'>元</span>
				</div>
			</div>

			<div class="customer-info sale-wrap" v-if="role =='sale'"> 
				<span class="info-style pay-title">订单佣金</span>
			    <span class="info-style pay-money sale-co">¥{{detailList.commission_price}}</span>
			</div>

			
			<div class="customer-info pm" v-if="detailList.order_append_price>0 && role!='sale'">
				<span class="info-style pay-title">追加费用</span>
			    <span class="info-style pay-money">¥{{detailList.order_append_price}}</span>
			</div>
			
		
		<div class="customer-info" v-if="role!='sale'">
			<span class="info-style pay-title">实付金额</span>
		    <span class="info-style pay-money">¥{{detailList.order_total_price}}</span>
		</div>
		
		
	    </li>
	</ul>
	
	
</template>

<script>
	import utils from '@/assets/jslibs/utils'
    export default {
		data(){
			return{
				copyOrder:"",
				utils
			}
		},
		props:{
			detailList:{
				type: Object,
			},
			
			notSale:{
				type: Boolean,
			},
			
			role:{
				type: String,
			}
			
		},
        name: 'submitPay',
        methods: {
			submit(){
				this.$emit("submitClick")
			}
        }
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15);font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;}
	.order-detail{margin-bottom: 10px;background: #fff;padding-bottom: 10px;}
	.link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 15px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.customer-info{padding: 10px 15px 2px 15px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap}
	.info-style{color:rgba(74,74,74,1);font-size: 14px}
	.pm{padding-top: 4px;}
	.pay-money{font-size: 18px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(20,20,20,1);}
	.discount-wrap{border-bottom: 0.026667rem solid #EEEEEE;margin: 0.266667rem 0.4rem 0.053333rem 0.4rem;padding: 0;padding-bottom: 0.32rem;}
	.discount{color:rgba(255,134,48,1);font-size: 14px;padding-left: 4px}
	.dan-wei{color: #4a4a4a;font-size: 14px;}	
	.copy-logo{width: 12px;height: 12px}
	.info-r{flex: 1;text-align: right;margin-right: 8px}
	.sale-co{color:rgba(255,134,48,1)}
	.blod-co{color: #ff8630;font-weight: bold;}
</style>
